<template>
  <div v-show.async="show">
    <template v-if="order.status >= 4">
      <div class="panel mt-20">
        <div class="header flex-row-between">
          <h2>采购管理</h2>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="startPurchaseOrderFormer()"
            v-if="order.deleted == 0 && order.status != 1 && order.status < 20"
            v-permission="Auth.orderPurchaseNew"
            >添加采购单</el-button
          >
        </div>
        <el-table
          v-if="!isMobile()"
          :data="order.purchase_orders"
          style="width: 100%"
          empty-text="本订单还未添加采购单"
          key="order.purchase_orders"
        >
          <el-table-column label="采购单号">
            <template slot-scope="scope">
              <purchase-link
                :id="scope.row.id"
                :number="scope.row.number"
                :origin="1"
              ></purchase-link>
            </template>
          </el-table-column>
          <el-table-column label="产品明细" min-width="250">
            <template slot-scope="scope">
              <span class="item-tag" v-for="item in scope.row.items">
                {{ item.item.name }}
                <i>x{{ item.count }}</i>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user.name"
            label="创建人"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="user.name"
            label="创建时间"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ formatTime(scope.row.created_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <status-tag
                :type="PurchaseOrderStatusMap[scope.row.status].type"
                :name="PurchaseOrderStatusMap[scope.row.status].name"
              ></status-tag>
            </template>
          </el-table-column>
        </el-table>
        <ul v-else class="list-style">
          <li v-for="item in order.purchase_orders">
            <div>
              <purchase-link
                :id="item.id"
                :number="item.number"
                :origin="1"
              ></purchase-link>
            </div>
            <div class="flex-row-between font-12">
              <span>{{ formatTime(item.created_at) }}</span>
              <status-tag
                :type="PurchaseOrderStatusMap[item.status].type"
                :name="PurchaseOrderStatusMap[item.status].name"
              ></status-tag>
            </div>
          </li>
        </ul>
        <div
          v-if="order.purchase_orders.length == 0 && isMobile()"
          class="text-info-12"
        >
          暂无采购记录。
        </div>
      </div>
      <div class="panel mt-20" v-if="order.status >= 4">
        <div class="header flex-row-between">
          <h2>发货管理</h2>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="startShippingRecordFormer()"
            v-if="order.status != 1 && order.status < 20"
            v-permission="Auth.orderShipNew"
            >添加发货</el-button
          >
        </div>
        <el-table
          v-if="!isMobile()"
          :data="order.shipping_records"
          style="width: 100%"
          empty-text="本订单未有发货记录"
          align="center"
        >
          <el-table-column label="发货单号" width="160">
            <template slot-scope="scope">
              <span
                @click="openShippintRecordDetail(scope.row)"
                class="text-primary pointer"
                >{{ scope.row.code_number }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="产品明细" min-width="250">
            <template slot-scope="scope">
              <span class="item-tag" v-for="item in scope.row.items">
                {{ item.item.name }}
                <i>x{{ item.item_number }}</i>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user.name"
            label="创建人"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="user.name"
            label="发货类型"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.supplier_id > 0 ? '供应商发货' : '仓库发货'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user.name"
            label="创建时间"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ formatTime(scope.row.created_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <status-tag
                :type="ShippingRecordStatusMap[scope.row.status].type"
                :name="ShippingRecordStatusMap[scope.row.status].name"
                v-if="!scope.row.supplier_id > 0"
              ></status-tag>
            </template>
          </el-table-column>
        </el-table>
        <ul v-else class="list-style">
          <li v-for="item in order.shipping_records">
            <div>
              <span
                @click="openShippintRecordDetail(item)"
                class="text-primary pointer"
                >{{ item.code_number }}</span
              >
            </div>
            <div class="font-12">
              {{ item.supplier_id > 0 ? '供应商发货' : '仓库发货' }}
            </div>
            <div class="flex-row-between font-12">
              <span>{{ formatTime(item.created_at) }}</span>
              <status-tag
                :type="ShippingRecordStatusMap[item.status].type"
                :name="ShippingRecordStatusMap[item.status].name"
                v-if="!item.supplier_id > 0"
              ></status-tag>
            </div>
          </li>
        </ul>
        <div
          v-if="order.shipping_records.length == 0 && isMobile()"
          class="text-info-12"
        >
          暂无发货记录。
        </div>
      </div>
    </template>
    <template v-else>
      <div class="panel mt-20 text-gray">
        订单进入“采购/发货”阶段后，可进行采购和发货操作。
      </div>
    </template>

    <purchase-order-former
      :model="purchaseOrderForm"
      :fixedOrder="true"
      :purchaseItems="purchaseItems"
      :show.sync="purchaseOrderVisible"
      @created="createdPurchaseOrder"
    ></purchase-order-former>
    <shipping-record-former
      :model="shippingRecordForm"
      :show.sync="shippingRecordVisible"
      :products="shippingItems"
      @created="createdShippingRecord"
      @updated="updatedShippingRecord"
    ></shipping-record-former>
    <shipping-record-detail
      :model="selectedShippingRecord"
      :show.sync="shippingRecordDetailVisible"
      @edit="startShippingRecordFormer"
      @deleted="deletedShippingRecord"
    ></shipping-record-detail>
  </div>
</template>

<script>
import {
  customerCollectionList,
  invoiceRecordList,
} from '../../service/getData'
import { formatTime } from '@/util/index'
import { clone } from '@/util'
import PurchaseOrderDetail from '@/components/purchase_order_detail'
import PurchaseOrderFormer from '@/components/purchase_order'
import StockOutFormer from '@/components/stock_out'
import {
  PurchaseOrderStatusMap,
  ShippingRecordStatusMap,
} from '@/config/global.js'
import ShippingRecordFormer from '@/components/shipping_record'
import store from '@/store/store'
import ShippingRecordDetail from '@/components/shipping_record_detail'
import { isMobile } from '../../util'

export default {
  components: {
    PurchaseOrderDetail,
    PurchaseOrderFormer,
    ShippingRecordFormer,
    ShippingRecordDetail,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
    },
  },
  data() {
    return {
      formatTime,
      isMobile,
      userInfo: store.getters.userInfo,
      PurchaseOrderStatusMap,
      ShippingRecordStatusMap,
      selectedPurchaseOrder: null,
      customerCollectionForm: {},
      purchaseOrderForm: {},
      purchaseOrderVisible: false,
      shippingRecordEditIndex: 0,
      shippingRecordForm: {},
      shippingRecordVisible: false,
      selectedShippingRecord: null,
      shippingRecordDetailVisible: false,
    }
  },
  computed: {
    purchaseItems() {
      var items = []
      if (!this.order) {
        return items
      }
      this.order.order_info.products.map((product) => {
        let sitem = clone(product.item)
        sitem.count = product.count
        sitem.price = product.price
        items.push(sitem)
      })
      this.order.order_info.devices.map((device) => {
        device.items.map((item) => {
          let sitem = clone(item)
          sitem.count = item.count
          sitem.price = item.price
          items.push(sitem)
        })
      })

      return items.filter((item) => {
        var needAdd = true
        this.order.purchase_orders.map((order) => {
          order.items.map((i) => {
            if (i.id == item.item_id) {
              if (item.count <= i.count) {
                needAdd = false
              } else {
                item.count = item.count - i.count
              }
            }
          })
        })
        return needAdd
      })
    },
    shippingItems() {
      var items = []
      if (!this.order) {
        return items
      }
      this.order.order_info.products.map((product) => {
        let sitem = {}
        sitem.item_id = product.item_id
        sitem.count = product.count
        sitem.item = product.item
        sitem.price = product.price
        items.push(sitem)
      })
      this.order.order_info.devices.map((device) => {
        device.items.map((item) => {
          let sitem = {}
          sitem.item_id = item.item_id
          sitem.count = item.count
          sitem.item = item.item
          sitem.price = item.price
          items.push(sitem)
        })
      })

      return items.filter((item) => {
        var needAdd = true
        this.order.shipping_records.map((record) => {
          record.items.map((i) => {
            if (i.item_id == item.item_id) {
              if (item.count <= i.item_number) {
                needAdd = false
              } else {
                item.count = item.count - i.item_number
              }
            }
          })
        })
        return needAdd
      })
    },
  },
  watch: {
    show() {},
  },
  methods: {
    startPurchaseOrderFormer(order) {
      if (order) {
        this.purchaseOrderForm = order
      } else {
        this.purchaseOrderForm = {
          items: [],
          remark: '',
          amount: 0,
          customer_order_id: this.order.id,
        }
      }
      this.purchaseOrderVisible = true
    },
    createdPurchaseOrder(po) {
      this.order.purchase_orders.unshift(po)
    },
    startStockOutFormer() {
      this.stockOutForm = {
        category_id: 1,
        customer_order_id: this.order.id,
        applicant_id: '',
        transactor_id: '',
        stock_out_date: new Date(),
        remark: '',
        type: 1,
        items: this.stockOutItems,
      }
      this.stockOutVisible = true
    },
    createdStockOutBill(sob) {
      this.order.stock_out_bills.unshift(sob)
    },
    openPurchaseOrderDetail(po) {
      this.selectedPurchaseOrder = po
      this.purchaseOrderDetailVisible = true
    },
    startShippingRecordFormer(record) {
      if (this.shippingItems.length == 0) {
        this.$message({
          message: '订单产品已全部发货',
          type: 'error',
        })
        return
      }
      if (record) {
        let index = this.order.shipping_records.indexOf(record)
        this.shippingRecordEditIndex = index
        record.items.map((item) => {
          this.$set(item, 'price', item.unit_price)
          this.$set(item, 'number', item.item_number)
          return item
        })
        this.shippingRecordForm = record
      } else {
        this.shippingRecordForm = {
          remark: '',
          category_id: 1,
          applicant_id: this.userInfo.id,
          customer_order_id: this.order.id,
          express_number: '',
          express_company: '',
          supplier_id: null,
          items: [],
        }
      }
      this.shippingRecordVisible = true
    },
    createdShippingRecord(record) {
      this.order.shipping_records.unshift(record)
    },
    updatedShippingRecord(record) {
      if (this.shippingRecordEditIndex >= 0) {
        this.order.shipping_records.splice(
          this.shippingRecordEditIndex,
          1,
          record
        )
      }
    },
    deletedShippingRecord(record) {
      let index = this.order.shipping_records.indexOf(record)
      if (index >= 0) {
        this.order.shipping_records.splice(index, 1)
      }
    },
    openShippintRecordDetail(record) {
      this.selectedShippingRecord = record
      this.shippingRecordDetailVisible = true
    },
    openPurchaseOrderDetail(po) {
      this.selectedPurchaseOrder = po
      this.purchaseOrderDetailVisible = true
    },
  },
}
</script>

<style scoped>
.el-date-editor .el-range-input {
  width: 100px !important;
}
</style>